// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"b72e1574","127":"2892adba","146":"0aafc887","150":"0794a86a","300":"d611eb88","321":"393ce705","520":"fd14484b","711":"b6fbd14f","803":"a5b62cdc","840":"0142cb51","849":"34200538","861":"3c45f77b","929":"84a72320","937":"926372d8"}[chunkId] + ".chunk.js";
};